// @ts-strict-ignore
import { Transforms, Editor, Node, Element as SlateElement } from 'slate';
import { TitleMediumElement } from 'src/components/textEditor/customTypes';

// this way we can enforce the layout of the editor
export const withTitleLayout = (editor: Editor) => {
  const {
    normalizeNode
  } = editor;
  editor.normalizeNode = ([node, path]) => {
    if (path.length === 0) {
      if (editor.children.length < 1) {
        const titleMedium = ({
          type: 'title-medium',
          children: [{
            text: ''
          }]
        } as TitleMediumElement);
        Transforms.insertNodes(editor, titleMedium, {
          at: path.concat(0)
        });
      }

      // if a block already exist, block the insertion of a new block
      if (editor.children.length > 1) {
        Transforms.removeNodes(editor, {
          at: Node.children[1]
        });
      }

      // @ts-expect-error needs redef of a custom type, but works fine
      for (const [child, childPath] of Node.children(editor, path)) {
        let type: string;
        const slateIndex = childPath[0];
        const enforceType = type => {
          if (SlateElement.isElement(child) && child.type !== type) {
            const newProperties: Partial<SlateElement> = {
              type
            };
            Transforms.setNodes<SlateElement>(editor, newProperties, {
              at: childPath
            });
          }
        };
        switch (slateIndex) {
          case 0:
            type = 'title-medium';
            enforceType(type);
            break;
          default:
            break;
        }
      }
    }
    return normalizeNode([node, path]);
  };
  return editor;
};